import _ from "lodash";

import { formatBytes } from "@utils/formatBytes";

const calTotalByKey = ({ dataItem, filterBy }) => {
  return _.chain(dataItem)
    .filter((item) => {
      const type = _.get(item, ["type"]);
      return _.startsWith(type, filterBy);
    })
    .size()
    .value();
};

export const getOverviewMedia = ({ medias }) => {
  const overViews = _.chain(medias)
    .thru((data) => {
      const totalImages = calTotalByKey({
        dataItem: data,
        filterBy: "image",
      });
      const totalVideos = calTotalByKey({
        dataItem: data,
        filterBy: "video",
      });
      const totalAudio = calTotalByKey({
        dataItem: data,
        filterBy: "audio",
      });
      const totalMedia = _.size(data);

      const mediaSize = _.chain(data)
        .filter((dataItem) => {
          return !_.get(dataItem, ["is_share"]);
        })
        .sumBy("size")
        .thru((dataItem) => {
          const sizeUnitGB = formatBytes({ bytes: dataItem });
          return sizeUnitGB;
        })
        .value();

      const sumActiveMedia = _.sumBy(data, (item) => {
        return _.get(item, ["isInUse"]) ? 1 : 0;
      });
      const sumInActiveMedia = _.sumBy(data, (item) => {
        return !_.get(item, ["isInUse"]) ? 1 : 0;
      });

      return {
        mediaSize: `${mediaSize}`,
        totalActiveMedia: `${sumActiveMedia} / ${totalMedia} files`,
        totalInactiveMedia: `${sumInActiveMedia} / ${totalMedia} files`,
        totalImages: `${totalImages} files`,
        totalVideos: `${totalVideos} files`,
        totalAudio: `${totalAudio} files`,
      };
    })
    .value();

  return overViews;
};
